import { ChevronLeft, ChevronRight } from "lucide-react";

export const PrevArrow = ({ onClick }) => (
  <button
    onClick={onClick}
    className="
      absolute left-[-60px] top-1/2 -translate-y-1/2
      w-12 h-12 rounded-full
      bg-white border border-gray-200
      shadow-lg
      flex items-center justify-center
      hover:bg-[#fd3e3d] hover:text-white
      transition
      z-20
    "
  >
    <ChevronLeft size={22} />
  </button>
);

 export const NextArrow = ({ onClick }) => (
  <button
    onClick={onClick}
    className="
      absolute right-[-60px] top-1/2 -translate-y-1/2
      w-12 h-12 rounded-full
      bg-white border border-gray-200
      shadow-lg
      flex items-center justify-center
      hover:bg-[#fd3e3d] hover:text-white
      transition
      z-20
    "
  >
    <ChevronRight size={22} />
  </button>
);
